export default {
  getPartners: (state) => state.partners,
  getLoadingPartners: (state) => state.loadingPartners,
};